import * as moment from "moment";

export const getCurrentDate = (separator = "") => {
  const newDate = new Date();
  const date = newDate.getDate();
  const month = newDate.getMonth() + 1;
  const year = newDate.getFullYear();

  return `${year}${separator}${month < 10 ? `0${month}` : `${month}`
  }${separator}${date < 10 ? `0${date}` : `${date}`}`;
};

export const getAccountApi = () => {

  switch (window.rucmonkeyGlobalConfigs?.serviceUrl) {
  case "STAGING":
    return process.env.REACT_APP_LOGIN_STAGING;
  case "STAGING2":
    return process.env.REACT_APP_LOGIN_STAGING2;
  case "PROD":
    return process.env.REACT_APP_LOGIN_PROD;
  case "LOCAL":
    return process.env.REACT_APP_LOGIN_LOCAL;
  default:
    return process.env.REACT_APP_LOGIN_PROD;
  }
};

export const getVehicleIcon = (RucMonkeyVehicleTypeId) => {
  switch (RucMonkeyVehicleTypeId) {
  case "1":
    return "/assets/img/truck.png";
  case "2":
    return "/assets/img/pickup.png";
  case "3":
  case "4":
    return "/assets/img/trailer.png";
  case "5":
    return "/assets/img/petrol-vehicle.png";
  default:
    return "/assets/img/truck.png";
  }
};


export const setTimeStamp = (time) => {
  if (time) {
    return moment(time).format("DD/MM/YYYY HH:mm:ss");
  }
  return "";
};
export const setDate = (time) => {
  if (time) {
    return moment(time).format("DD/MM/YYYY");
  }
  return "";
};

export const setUTCTimeStringFormat = (time) => {
  if (time) {
    return time.replace(/T/g, " ").replace(/Z/g, " ");
  }
  return "";
};



export const noop = () => {
};


export const getPromise = () => {
  return new Promise(resolve => {
    resolve();
  });
};
